import { requestApi } from 'api';
import { withUpload } from 'api/paths';

interface getFileDownloadUrlProps {
  fileId: string;
  token: string | null;
  otp: string | null;
  fromDocumentBucket?: boolean;
}

interface getFileDownloadUrlResponse {
  signedUrl: string;
}

export async function getFileDownloadUrl({
  fileId,
  otp,
  token,
  fromDocumentBucket = true,
}: getFileDownloadUrlProps): Promise<getFileDownloadUrlResponse> {
  return requestApi<getFileDownloadUrlResponse>({
    url: withUpload(`/files/${fileId}/download-url`),
    method: 'GET',
    credentials: true,
    params: {
      otp,
      token,
      fromDocumentBucket,
    },
  }).then((response) => response.data);
}
